<template>
  <Error icon-name="hidden" title="You don’t have permission to view this page">
    <Stack>
      <Text align="center">If you think this is a mistake please contact the primary account holder</Text>
    </Stack>
  </Error>
</template>
